// import globals from '../globals';
// import Stack from '../services/contentstack-service';
import ContentStack from '../../mixins/contentstack-mixin';

export default {
  name: 'vx-contentstack',
  mixins: [ContentStack],
  data() {
    return {
      cs,
    };
  },
  // components: {},
  // // created() {
  // //   Stack.getEntry(this.contententryid, this.handleData, this.handleError);
  // //   // console.log(this.$slots.default);
  // // },
  // render() {
  //   return this.$slots.default[0];
  // },
  // props: [
  //   'contententryid',
  // ],
  // data() {
  //   return {
  //     cs: {
  //       entryID: '',
  //       rich_text_editor: '',
  //       title: '',
  //       group: {
  //         link: { title: '', href: '' },
  //       },
  //     },
  //   };
  // },
};



// WEBPACK FOOTER //
// ./src/components/common/contentstack/vx-contentstack/vx-contentstack.js